module.exports = __webpack_public_path__ + "img/coming-soon.d85b63ce.svg";